import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../../i18n/use-translation';
import { createSetTabRoleAction } from '../../../store/modal/factory';
import { Button } from '../../atoms/button';
import { Wrapper } from '../../atoms/wrapper';
import { Color } from '../../enums/color';
import { Section } from '../../enums/container';
import { Size } from '../../enums/size';
import { RegisterBlock } from '../../organism/Auth/Register/RegisterBlock';
import * as styles from './join_section.module.sass';
import { JoinSectionProp } from './props.types';
import {HeroSectionType} from "../HeroSection/enum/hero-section-type";

export const JoinSection = (props: JoinSectionProp) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const role = useSelector((state: { modal: { role: string } }) => state.modal.role);

  const setRole = (role: string) => dispatch(createSetTabRoleAction(role));
  const tabLabels = [];

  const showImageHandler = () => {
    switch (props.page) {
      case 'patient':
        return <img src="https://moniheal.net/m-public/homepage/5e943508da92b067857264.svg" className={styles.mocap_img} alt="" />;
      case 'clinic':
        return <img src="https://moniheal.net/m-public/homepage/5e94350861268501424415.svg" className={styles.mocap_img} alt="" />;
      case 'doctor':
        return <img src="https://moniheal.net/m-public/homepage/5e94350924199557640259.svg" className={styles.mocap_img} alt="" />;

      default:
        return <img src="https://moniheal.net/m-public/homepage/5e943508da92b067857264.svg" className={styles.mocap_img} alt="" />;
    }
  }

  // @fixme: remove any with proper type
  for (const [key, item] of Object.entries(props.tabs) as any) {
    tabLabels.push(
      <Button
        size={Size.EXTRA_SMALL}
        color={Color.TABBATTON}
        className={classNames(styles.choose_button, {
          [styles.active]: role === key || (!role?.length && item.active),
        })}
        text={item.title}
        key={key}
        textClassName={classNames(styles.tabs_text)}
        onClick={() => setRole(key)}
      />,
    );
  }

  return (
    <Wrapper section={Section.JOIN} className={styles.join_wrapper} cardClassName={styles.join_section}>
      <div className={styles.join_section_container}>
        <h2 className={styles.join_heading}>{props.title}</h2>
        <p className={styles.description}>{props.description}</p>
      </div>
      <div className={classNames(styles.form_container)}>
        {showImageHandler()}
        {/*<RegisterBlock className={styles.registr_form}>*/}
        {/*  <div className={styles.tab_container}>*/}
        {/*    {tabLabels}*/}
        {/*    /!* <RoleChoose value={role} /> *!/*/}
        {/*  </div>*/}
        {/*</RegisterBlock>*/}
        {/*<p className={classNames(styles.conditions, styles.conditions_description)}>*/}
        {/*  {t('confirm_description')}*/}
        {/*  <a href={`/${props.locale}/page/agreement`} className={styles.conditions_link}>*/}
        {/*    {t('use_condition')}*/}
        {/*  </a>*/}
        {/*</p>*/}
      </div>
    </Wrapper>
  );
};
